/* import __COLOCATED_TEMPLATE__ from './phone-runbook.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type Store from '@ember-data/store';
import { action } from '@ember/object';
import type AppService from 'embercom/services/app-service';
import type { FinVoiceRunbook } from 'embercom/objects/ai-agent/fin-voice/fin-voice-runbook-options';
import { getLabelForRunbook } from 'embercom/objects/ai-agent/fin-voice/fin-voice-runbook-options';
import type FinVoiceNumberConfiguration from 'embercom/models/fin-voice/number-configuration';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: $TSFixMe;
    phoneNumberId?: string; // Optional - kept for compatibility but not used
    numberConfiguration?: FinVoiceNumberConfiguration;
    descriptionText?: string;
    updateRunbook: (runbook: FinVoiceRunbook) => Promise<void>;
  };
}

export default class PhoneRunbook extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare store: Store;
  @service declare appService: AppService;
  @service declare notificationsService: $TSFixMe;

  @tracked selectedRunbook: FinVoiceRunbook = 'none';

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);

    this.resetRunbook();
  }

  get savingDisabled() {
    return Boolean(
      this.numberConfiguration?.isSaving || this.selectedRunbook === this.savedRunbook,
    );
  }

  get errorMessage() {
    if (this.selectedRunbook === this.savedRunbook) {
      return this.intl.t(
        'operator.fin.setup.tabs.setup-and-go-live.phone.runbook.error-no-changes',
      );
    }
    return undefined;
  }

  get numberConfiguration() {
    return this.args.numberConfiguration;
  }

  get savedRunbook() {
    return this.numberConfiguration?.runbook || 'none';
  }

  get selectedRunbookName() {
    return this.intl.t(
      getLabelForRunbook(this.selectedRunbook) ||
        'operator.fin.setup.tabs.setup-and-go-live.phone.runbook.not-set-up',
    );
  }

  @action
  resetRunbook() {
    this.selectedRunbook = this.savedRunbook || 'none';
  }

  @action
  onRunbookChange(runbook: FinVoiceRunbook) {
    this.selectedRunbook = runbook;
  }

  @action
  async updateRunbook() {
    await this.args.updateRunbook(this.selectedRunbook);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::NumberConfiguration::PhoneRunbook': typeof PhoneRunbook;
  }
}
